import { useService } from '../../hooks/useService';
import { FormBase } from '../Interface';
import ServicePage from './ServicePage';
import ServiceReports from './ServiceReports';

export const ServiceMain = () => {
  const serviceState = useService();

  return (
    <FormBase
      name="Service"
      leftPanelContent={<ServicePage serviceState={serviceState} />}
      rightPanelContent={<ServiceReports serviceState={serviceState} />}
    />
  );
};
